import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import Slide from 'react-reveal/Slide';

class ProjectPortraitImage extends Component {

  render() {

  	let { portrait, portraitSecond, imageTypeFirst, imageTypeSecond } = this.props

    let imageLayoutFirst,
        imageLayoutSecond;

    if (imageTypeFirst === 'gif') {
      imageLayoutFirst =  <div className='projects__image'>
                            <div className='gatsby-image-wrapper-constrained gif'>
                              { portrait && 
                                <img className='gif' src={portrait?.sourceUrl} alt={portrait.title} />
                              }
                            </div>
                          </div>
    } else {
      imageLayoutFirst = <div>
                          { portrait && 
                            <GatsbyImage loading='lazy' image={getImage(portrait?.localFile)} alt={portrait.title} />
                          }
                        </div>
    }

    if (imageTypeSecond === 'gif') {
      imageLayoutSecond =  <div className='projects__image'>
                            <div className='gatsby-image-wrapper-constrained gif'>
                              { portraitSecond && 
                                <img className='gif' src={portraitSecond?.sourceUrl} alt={portraitSecond.title} />
                              }
                            </div>
                          </div>
    } else {
      imageLayoutSecond = <div>
                            { portraitSecond && 
                              <GatsbyImage loading='lazy' image={getImage(portraitSecond?.localFile)} alt={portraitSecond.title} />
                            }
                          </div>
    }

    return (
      <section className='portrait-images'>
        <div className='portrait-images__container'>
          <Slide bottom>
          <div className='col'>
            {imageLayoutFirst}
          </div>
          </Slide>
          <Slide bottom delay={300}>
          <div className='col'>
            {imageLayoutSecond}
          </div>
          </Slide>
        </div>
      </section>
    )
  }
}

export default ProjectPortraitImage